import { LLMResponse } from '../types';
import { QueryIntent } from './queryAnalyzerLLM';
import { FandomSearchResult } from './search';

const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL || 'http://localhost:8000';

export async function generateOverview(
  query: string, 
  intent: QueryIntent,
  searchContext?: FandomSearchResult[]
): Promise<LLMResponse> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/llm/generate-overview`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        intent,
        searchContext
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error calling backend LLM API:', errorText);
      throw new Error(`Backend LLM API error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data as LLMResponse;
  } catch (error) {
    console.error('Error in generateOverview:', error);
    throw new Error('Failed to generate overview');
  }
}

// Helper function to extract concepts from text if JSON parsing fails
export function extractConceptsFromText(text: string): string[] {
  // Simple extraction: look for bullet points or numbered lists
  const lines = text.split('\n');
  const concepts: string[] = [];
  
  lines.forEach(line => {
    // Check for bullet points or numbers at start of line
    const match = line.match(/^[\-\*•]\s*(.+)|^\d+\.\s*(.+)/);
    if (match) {
      concepts.push(match[1] || match[2]);
    }
  });
  
  return concepts.slice(0, 7); // Limit to 7 concepts
}